import React from 'react';
import { Field } from 'react-final-form';
import { Error } from "./error";
import { baseConfig } from "../util/config";

export function Configuration(props) {
    const required = props.validation;

    return (
    <div>
        <h3>Base Configuration*</h3>
        <div>
          {baseConfig.map((cfg) =>
            <label key={cfg.size}>
              <Field name="base_configuration" component="input" type="radio" value={cfg.size} validate={required} />{' '}
              {cfg.size.charAt(0).toUpperCase() + cfg.size.slice(1)} ({cfg.cores} cores and {cfg.memory}GB memory)
            </label>
          )}
          <Error name="base_configuration" />
        </div>

        <h3>Operating System*</h3>
        <div>
          <label>
            <Field name="vmos" component="input" type="radio" value="Windows" validate={required} />{' '}
            Windows
          </label>
          <label>
            <Field name="vmos" component="input" type="radio" value="CentOS" validate={required} />{' '}
            CentOS
          </label>
          <Error name="vmos" />
        </div>
    </div>
    );
}
